import { IPromise } from 'angular';

import { RequestHelper } from '../../ts/helpers/RequestHelper';
import { ResultHelper } from '../../ts/helpers/ResultHelper';
import { Module } from '../../ts/Module';
import { DeleteDataSourceVersionsRequest } from '../../ts/ServerApi/requests/DeleteDataSourceVersionsRequest';
import {
  GetDatasourceVersionsRequest,
  IGetDatasourceVersionsResult,
} from '../serverApi/requests/getDatasourceVersionsRequest';
import { IDatasourceRevision } from '../serverApi/types/IDatasourceRevision';
import { IResult } from '../../ts/ServerApi/types/IResponse';
import { ErrorNotifyingServer } from '../../ts/services/ErrorNotifyingServer';
import { FetcherFactory } from '../../ts/services/FetcherFactory';
import { ServerService } from '../../ts/services/ServerService';
import { Resource } from '../../ts/resources/Resource';

export class DatasourceRevisions extends Resource<IDatasourceRevision>  {

  public static $inject = ['ErrorNotifyingServer', 'FetcherFactory'];

  private server: ServerService;

  constructor(private ErrorNotifyingServer: ErrorNotifyingServer, FetcherFactory: FetcherFactory) {
    super(FetcherFactory.getServerResourceFetcher(
      GetDatasourceVersionsRequest,
      (result: IGetDatasourceVersionsResult) => result.versions));

    this.server = ErrorNotifyingServer.getServerService();
  }

  public del = (id: string): IPromise<IResult> => {
    return this.ErrorNotifyingServer.sendRequestsAndDelay(
      RequestHelper.buildRequests([id], (idsBlock) => new DeleteDataSourceVersionsRequest(idsBlock)),
      ResultHelper.combineResults);
  }

}

Module.instance().service('DatasourceRevisions', DatasourceRevisions);
